import { render, staticRenderFns } from "./scoring-cycle-list.vue?vue&type=template&id=67292fce&scoped=true"
import script from "./scoring-cycle-list.vue?vue&type=script&lang=js"
export * from "./scoring-cycle-list.vue?vue&type=script&lang=js"
import style0 from "./scoring-cycle-list.vue?vue&type=style&index=0&id=67292fce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67292fce",
  null
  
)

export default component.exports